import parse from "html-react-parser";

/**
 * Utility function to safely parse HTML content from text editor
 * Handles both escaped and unescaped HTML content
 * @param {string} htmlString - The HTML string to parse
 * @returns {React.ReactNode|string} - Parsed React elements or original string
 */
export const parseHtmlContent = (htmlString) => {
  if (!htmlString) return "";
  
  try {
    // Check if content is HTML-encoded and needs unescaping
    const content = htmlString.includes('&lt;') || htmlString.includes('&gt;') || htmlString.includes('&amp;')
      ? unescape(htmlString) 
      : htmlString;
    
    // Only parse if content contains HTML tags
    if (content.includes('<') && content.includes('>')) {
      return parse(content);
    }
    
    // Return plain text as-is
    return content;
  } catch (error) {
    console.warn('Error parsing HTML content:', error);
    return htmlString;
  }
};

/**
 * Strips HTML tags and returns plain text
 * @param {string} htmlString - The HTML string to strip
 * @returns {string} - Plain text content
 */
export const stripHtmlTags = (htmlString) => {
  if (!htmlString) return "";
  
  try {
    const content = htmlString.includes('&lt;') || htmlString.includes('&gt;') || htmlString.includes('&amp;')
      ? unescape(htmlString) 
      : htmlString;
    
    // Remove HTML tags
    return content.replace(/<[^>]*>/g, '').trim();
  } catch (error) {
    console.warn('Error stripping HTML tags:', error);
    return htmlString;
  }
};